// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".content[data-v-4adb230f]{font-family:Roboto Mono,monospace;font-size:12px;display:grid;grid-template-columns:3fr 2fr;grid-gap:16px}.content .label[data-v-4adb230f]{text-align:right}.content .value[data-v-4adb230f]{color:#42b983}", ""]);
// Exports
module.exports = exports;
